// Function loadFeatureBlock loads the FeatureBlock class by dynamically importing the js on demand if needed

export function loadFeatureBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-feature-block-chunk" */ '../widgets/featureBlock').then(wg => {

		const { FeatureBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="FeatureBlock"]');

		if(!$wg) {
			// console.info('FeatureBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="FeatureBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new FeatureBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new FeatureBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the FeatureBlock widget');

}
